import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import ImpersonatePicker from '../pages/ImpersonatePicker';
import BugReporter from './BugReporter';
import './TopBar.css';

// The Botfield Suite hub — :3100 in local dev, the apex domain in production.
function hubUrl() {
  const h = window.location.hostname;
  return (h === 'localhost' || h === '127.0.0.1' || h === '[::1]' || h.endsWith('.local'))
    ? 'http://localhost:3100'
    : 'https://botfield.ai';
}

export default function TopBar() {
  const {
    email, realEmail, impersonating,
    isAdmin, isSteering, periods,
    stopImpersonating,
  } = useAuth();

  // The old "Help / Bug Report" button + modal (POST /api/diHelpEmail) lived here.
  // Removed in favor of <BugReporter />, which captures console/network context
  // with the report instead of asking the user to describe it twice.

  // A user may be in several concurrent active cycles. Show one badge per
  // applicable period (compact); fall back to nothing when there are none.
  const activePeriods = periods || [];

  // Admin controls visible if the REAL user is admin. Infer from isAdmin when
  // not impersonating, and from the presence of impersonating state (only
  // admins can impersonate).
  const adminUI = isAdmin || !!impersonating;

  return (
    <>
      <header className="topbar">
        <div className="topbar-left">
          <Link to="/" className="topbar-brand">
            <span className="topbar-logo">
              <img
                className="topbar-logo-img"
                src="/KeithBotfieldWebFavicon.svg"
                alt=""
                aria-hidden="true"
              />
            </span>
            BMSS Data Integrity
          </Link>
          {activePeriods.map(p => (
            <span key={p.period} className="topbar-period active" title={p.description || ''}>
              {p.label || p.period}
            </span>
          ))}
        </div>
        <div className="topbar-right">
          {/* Home link hidden until the hub apex (botfield.ai) is wired. The
              `false &&` guard keeps hubUrl referenced so it isn't flagged
              unused; drop the guard when the hub is prod-ready. */}
          {false && (
          <a
            href={hubUrl()}
            className="topbar-steering-link"
            title="Return to the Botfield Suite hub"
          >
            <i className="fas fa-home" /> Home
          </a>
          )}
          {adminUI && <ImpersonatePicker />}
          {impersonating && (
            <button
              className="topbar-exit-impersonate"
              onClick={stopImpersonating}
              title="Stop viewing as another user"
            >
              <i className="fas fa-sign-out-alt" /> Exit View As
            </button>
          )}
          {(isSteering || isAdmin) && (
            <Link to="/steering" className="topbar-steering-link">
              <i className="fas fa-chart-pie" /> Steering
            </Link>
          )}
          {isAdmin && (
            <Link to="/admin" className="topbar-admin-link">
              <i className="fas fa-cog" /> Admin
            </Link>
          )}
          <span className="topbar-email">{email}</span>
          <BugReporter />
        </div>
      </header>

      {impersonating && (
        <div className="topbar-impersonate-banner">
          <i className="fas fa-user-secret" />
          Viewing as <strong>{impersonating}</strong>
          {realEmail && <span className="topbar-impersonate-real"> (you are {realEmail})</span>}
          <button className="topbar-impersonate-exit" onClick={stopImpersonating}>
            Exit View As
          </button>
        </div>
      )}
    </>
  );
}
